// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"10be9925","787":"032f7813"}[chunkId] + ".chunk.js";
};